import { motion } from "framer-motion";
import { Check, CheckCheck, Soup, ChefHat, Bell, Utensils } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { ORDER_FLOW, ORDER_STATUS, isTerminalStatus } from "@/lib/orders";

const META = {
  [ORDER_STATUS.PLACED]: { icon: Soup, key: "statusReceived" },
  [ORDER_STATUS.PREPARING]: { icon: ChefHat, key: "statusPreparing" },
  [ORDER_STATUS.READY]: { icon: Bell, key: "statusReady" },
  [ORDER_STATUS.SERVING]: { icon: Utensils, key: "statusServing" },
  [ORDER_STATUS.COMPLETED]: { icon: CheckCheck, key: "statusCompleted" },
};

export function OrderStatusTimeline({ status }) {
  const { t } = useLang();
  const currentIdx = ORDER_FLOW.indexOf(status);
  const finished = isTerminalStatus(status);

  return (
    <div className="space-y-1" data-testid="order-status-timeline">
      {ORDER_FLOW.map((s, i) => {
        const done = i < currentIdx || (finished && i === currentIdx);
        const active = i === currentIdx && !finished;
        const Icon = META[s].icon;
        return (
          <div key={s} className="flex items-stretch gap-3">
            <div className="flex flex-col items-center">
              <motion.div
                initial={false}
                animate={{ scale: active ? 1 : 0.92 }}
                className={`relative grid h-10 w-10 place-items-center rounded-full transition-colors ${
                  done
                    ? "bg-success text-white"
                    : active
                    ? "brand-gradient text-white"
                    : "bg-secondary text-muted-foreground"
                }`}
              >
                {active && <span className="absolute inset-0 animate-pulse-ring rounded-full bg-primary/40" />}
                {done ? <Check className="h-5 w-5" /> : <Icon className="h-5 w-5" />}
              </motion.div>
              {i < ORDER_FLOW.length - 1 && (
                <div className={`my-1 w-0.5 flex-1 rounded-full ${i < currentIdx ? "bg-success" : "bg-border"}`} />
              )}
            </div>
            <div className={`pb-5 pt-2 ${i === ORDER_FLOW.length - 1 ? "pb-0" : ""}`}>
              <p
                className={`font-heading text-[15px] font-bold ${
                  active ? "text-foreground" : done ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {t(META[s].key)}
              </p>
              {active && <p className="text-xs text-primary">{t("justNow")}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
